import React from 'react';
import { View, Text, StyleSheet,Dimensions, Image,ImageBackground, TouchableWithoutFeedback, StatusBar } from 'react-native';
// import {Toast} from 'native-base';
import moment from 'moment';
import PaymentStrip from './paymentStrip';
// import Icon from 'react-native-vector-icons/Ionicons';
import { testStartTimeFromNow} from './'
// import { HeaderBackButton, showToaster as _showToaster } from './index';
const { width, height } = Dimensions.get('window');

const bgImage = require('./../assets/assets_png/file_ex.png');
const star = require('../assets/assets_png/star1.png');
const clock = require('../assets/assets_png/clock.png');
const play = require('../assets/assets_png/play.png');

export const isPastDate = date => moment() > moment(date);




 
const DateComponent = ({startDate, endDate}) => {
    // const isValidStartDate = moment(startDate).isValid();
    // const isValidEndDate = moment(endDate).isValid();

    return(
        <>
         <Image source={clock} style={{ width: 28, height: 28}}/>
         {/* <Icon name='ios-time' color='rgba(255,255,255, 0.65)' size={28} /> */}
                <View style={styles.dateWrapper}>
                    <View style={styles.flexRow}>
                        <Text style={styles.dayText}>
                            {
                                moment(startDate).format('ddd')
                            }
                            {', '}
                        </Text>
                        <Text style={[styles.dayText]}>
                            {moment(startDate).format('MMMM D')}
                        </Text>
                    </View>
                    <Text style={styles.timeText}>
                        {
                            moment(startDate).format('LT')
                        }
                    </Text>
                </View>
                <View style={styles.flexRow}>
                    <Text style={{color: '#fff', fontSize: 20, fontWeight: '700'}}> - </Text>
                </View>
                <View style={styles.dateWrapper}>
                    <View style={styles.flexRow}>
                        <Text style={styles.dayText}>
                        {
                                moment(endDate).format('ddd')
                            }
                            {', '}
                        </Text>
                        <Text style={[styles.dayText]}>
                            {moment(startDate).format('MMMM D')}
                        </Text>
                    </View>
                    <Text style={styles.timeText}>
                        {
                            moment(startDate).format('LT')
                        }
                    </Text>
                </View>
        </>
    )
}

// const showToaster = (msg) => {
//     _showToaster(msg);
//     // Toast.show({
//     //     text: msg
//     // })
// }

const TestSeriesTestDetailsButton = ({
  testDate,
  endDate,
    isTestCompleted,
    testSeriesTestId,
    goToScreen
}) => {
    
    return (
        <TouchableWithoutFeedback
        onPress={() => {
            if (moment(testDate) > moment()) {
                const remainigTime = testStartTimeFromNow(testDate);
                // showToaster(`Test starts ${remainigTime}`)
                return
            };
            // if (isPastDate(endDate)) return showToaster('Test Expired');
            // if (isTestCompleted) return goToScreen('/ShowResults', testSeriesTestId);
            goToScreen('TestTerms', testSeriesTestId);
                        
        }}
        >
            <View style={[styles.buyNow, ]}>
            <Text style={{fontSize: 20, fontWeight: '700', 
            color: '#fff', }}> { isTestCompleted ? 'Result' : 'Start Test' }</Text>
            </View>
        </TouchableWithoutFeedback>
    )
}

const TestSeriesDetailsComponent = ({
    data, 
    // isTestCompleted,
    navigation
}) => {
 
    const {
        completed,
        duration,
        end_date_time,
        id,
        image_url,
        material_test_status,
        no_of_questions,
        test_date,
        title,

    } = data || {};
    const isTestCompleted = completed || material_test_status === "submitted" || isPastDate(end_date_time)
   
    const goToScreen = (screen, testSeriesTestId) => {
        navigation.navigate(screen, {
            testId: id,
            isMaterialTest: true
        })
    }
    

    return(
        <View
        style={styles.detailsComponent}
        >
        <ImageBackground 
            source={{uri: image_url}}
            style={{
                width: '100%', 
                height: '100%' ,
                position: 'relative',
            
            }}
            // imageStyle={{  
            //     borderTopLeftRadius: 30,
            //     borderTopRightRadius: 30,
                
            // }}
            
        >
            <View style={{flex: 1, position: 'relative', zIndex: 1000}}>
            <View style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginTop: 22
            }}>
            
            <View />
              <View style={{flexDirection: 'row', flex: 1, justifyContent: 'space-between', alignItems: 'center', width: '100%', paddingVertical: 8, paddingTop: 12, paddingLeft: 10}}>
                  <View>
                    {/* <HeaderBackButton position style={{height: 30, width: 30, borderWidth: 2}} secondary />
                    <StatusBar barStyle='light-content' backgroundColor='rgba(0,0,0,0)' /> */}
                  </View>
                 
                </View>
             
            </View>
            <View style={styles.topicDetails}>
               <Text style={styles.examTitle}> 
                {title}
               </Text>
               {/* <Text style={styles.topicTitle}
                ellipsizeMode="tail" numberOfLines={2}
               > 
                    {title}
                </Text> */}
            </View>
            <View style={styles.dividerLine}/>  
            <View style={styles.dateBox}>
               <DateComponent  startDate={test_date} endDate={end_date_time} />
            </View>
            <View style={styles.bottomComponent}>
                {
                    
                    <>
                        <View style={{flexDirection: 'row', alignItems: 'center', marginHorizontal: 10, }}>
                            {/* <Image source={play} style={{width: 32, height: 32}}/>

                            <View style={{flexDirection:'column', justifyContent: 'flex-start', textAlign: 'justify', marginHorizontal: 10 }}>
                            <Text style={{color: '#fff', fontSize: 18,}}>Watch</Text>
                                <Text style={{color: '#fff', }}>Explanatory Video</Text>
                            </View> */}
                        </View>
                        <TestSeriesTestDetailsButton
                            testDate={test_date}
                            endDate={end_date_time}
                            testSeriesTestId={id}
                            isTestCompleted = {isTestCompleted}
                            goToScreen={goToScreen}

                        />
                    
                    </>
                  
                  
                }
                
            </View>
            </View>
            <View 
                style={{
                    ...StyleSheet.absoluteFill,
                    backgroundColor: 'rgba(0,0,0,0.70)',
                    zIndex: 1
                }}
            />
        </ImageBackground>
      
        </View>
    )
}

export default TestSeriesDetailsComponent;

const styles = StyleSheet.create({
    detailsComponent: {
        width: width,
        borderTopLeftRadius: 30,
        borderTopRightRadius: 30,
        height: 250,
        flexDirection: 'column',
        marginBottom: 20,
        position: 'relative',
        zIndex: 100,
        top: -5
    },
    topicDetails: {
      flex: 1,
      marginHorizontal: 10,
      flexDirection: 'column',
      justifyContent: 'flex-end',
      alignItems: 'flex-start',
      marginBottom: 8,      
    },
    examTitle: {
        fontSize: 23,
        fontWeight: '700',
        color: '#eddd00',
        textTransform: 'uppercase'
    },
    topicTitle: {
        fontSize: 18,
        fontWeight: '700',
        color: '#fff',
        textTransform: 'uppercase'
    },
    bottomComponent: {
        justifyContent: 'space-between',
        flexDirection: 'row',
       
       
    },
    duration: {
       borderWidth: 1,
       borderColor: '#fff',
       borderRadius: 10,
       height: 22,
       paddingHorizontal: 10,
       marginHorizontal: 2,
       alignItems: 'center',
       justifyContent :'center',
       marginHorizontal: 10,
     

    },
    buyNow: {    
        // paddingHorizontal: 30,
        width: '35%',
        height: 45,
        backgroundColor: '#249a00',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        borderTopStartRadius: 40,
        marginTop: 5
    },
    dividerLine: {
        borderWidth: 0.5,
        borderColor: 'rgba(255,255,255,0.55)',
        marginBottom: 5,
        marginHorizontal: 10
        
     },
     dateWrapper: {
        flexDirection:'column',
        justifyContent:'center',
        alignItems: 'flex-start', 
        marginHorizontal: 10      
    },
    flexRow: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    dayText: {
        color: '#fff',
        fontSize: 14,
        fontWeight: '400',
        textTransform: 'uppercase'
    },
    timeText: {
        color: '#fff',
        fontSize: 15,
        // fontWeight: '500',
    },
    dateBox:{
        // width:wp(95),
        // height:hp(5),
        flexDirection:'row',
        justifyContent: 'space-between',
        alignItems:'center',
        width: (width / 2 + 50),
        // paddingHorizontal: 12,
        marginLeft: 12,
        paddingBottom: 3,
        borderBottomWidth: 0.5,
        borderColor: 'rgba(255,255,255,0.55)',
         marginBottom: 5
        // backgroundColor: 'red'
      },
   
})